<nav id="sampleNav" class="dnb-global-header header-utility-btns navbar navbar-default">
  <div class="d-flex w-100">
    <div class="navbar-header">
      <button tabindex=0 role=button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
        data-target="#example-navbar-collapse-1">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <div style="float:left">
        <a aria-label="Link to Data Integration Toolkit" href="https://www.dnb.com"><span class="dnb-logo"></span> </a>
        <span class="integrate-title"><strong><span class="integrate-title">Data Integration
              Toolkit</span></strong></span>
      </div>
      <div id="example-search-collapse-1" class="search-group collapse navbar-collapse">
        <div class="input-group">
          <div class="search-selector input-group-btn">
          </div> <!-- /.input-group-btn -->
        </div>
      </div>
    </div>

    <!-- Collect the nav links, forms, and other content for toggling -->
    <div class="collapse navbar-collapse" id="example-navbar-collapse-3">
     
      <ul class="top-menu-items" style="float:right;font-size:10px;">
        <li><a aria-label="Link to Toolkit Home" [routerLink]="['/data-integration-toolkit-home']" >Toolkit Home</a></li>
        <li><a aria-label="Link to Contact Us" [routerLink]="'/unlocked/contact-us-dgx'">Contact Us</a></li>
        <li><a aria-label="Link to dnb.com" href="https://www.dnb.com/">dnb.com</a></li>
      </ul>
    </div><!-- /.navbar-collapse -->
  </div><!-- /.container-fluid -->
</nav>
<nav>
  <div style="background-color: #d7e0e4;">
    <ul class="nav navbar-nav" style="font-size:12px;">
      <li style="width: 304px;"></li>
      <li class="center-menu"><a aria-label="Link to Toolkit Overview" [routerLink]="'/unlocked/toolkit-overview'">Toolkit Overview</a></li>
      <li class="center-menu"><a aria-label="Link to Toolkit For Developers" [routerLink]="'/locked/tools-for-developers'">Tools for Developers</a></li>
      <li class="center-menu"><a aria-label="Link to Downloads" [routerLink]="['/locked/td-product-data-sheet-hyperlinks',{page:'softwareDownload'}]">Downloads</a></li>
      <li>
      </li>
    </ul>
  </div>
</nav>

<div class="app-container d-flex">
  <div id="left-hand-menu" class="col-sm dnb-left-hand-menu hidden-xs pl-0">
    <ul class="nav nav-pills nav-stacked d-inline">
      <li role="presentation" id="link_{{i}}" [ngStyle]="setLinkItemStyle(link)" class="nav-item active"
        *ngFor="let link of links; let i = index"><a aria-label="Link Label" class="nav-link" [routerLink]="link.path"
          (click)="sortLinksItems($event,link,i)">{{link.label}}</a></li>
    </ul>
  </div>
  <div class="col-sm pl-0">
    <div class="pt-3">
      <router-outlet></router-outlet>
    </div>
    <div class="clearfix"></div>
  </div>
</div>
